export default __webpack_public_path__ + "static/media/undraw_barber_3uel.4b3c0bb7.svg";